import BundleDetails from './BundleDetails';

export default BundleDetails;
